<template>
  <div class="mobile-header one-liner">
    {{ label }}
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mobile-header {
    width: 100%;
    height: 40px;

    color: map-get($colors, primary);
    font-size: 20px;
    font-weight: bold;

    display: block;
    text-align: center;

    margin-top: $header-height;
    padding: 10px 10px 0 10px;
  }
</style>